module.exports = __webpack_public_path__ + "media/src/images/icons/ellipse-81d1daa536a06acedd788ab089cdd654.svg";